/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const GlyphSocialYoutube = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 16 16",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M14.293 5.44s-.107-.907-.533-1.28c-.48-.534-1.014-.534-1.28-.534C10.666 3.52 8 3.52 8 3.52s-2.667 0-4.48.106c-.267.054-.8.054-1.28.534-.374.373-.534 1.28-.534 1.28S1.6 6.453 1.6 7.52v.96c0 1.013.106 2.08.106 2.08s.107.906.534 1.28c.48.533 1.12.48 1.386.533C4.64 12.48 8 12.48 8 12.48s2.666 0 4.48-.16c.266-.054.8-.054 1.28-.534.373-.373.533-1.28.533-1.28s.107-1.013.107-2.08v-.96c0-1.013-.107-2.026-.107-2.026zM6.666 9.653V6.08l3.467 1.813-3.467 1.76z"
  }));
};
export default GlyphSocialYoutube;